import React, { useState, Suspense, useEffect, useRef, lazy } from 'react'
import LoaderScreen from '../common/loader'
import { findObjctByValueFromArrayOfObject, getLoginToken, isEmpty, redirectToLogin } from '../common/helper'
import useToken from '../helpers/useTokens'
import { connect, Provider } from 'react-redux'
import { useSearchParams } from 'react-router-dom'
import { decryptText } from '../common/loginDecode'
import { cargoGetBranchBkgPermission, GetExemptedGoodsList, getOwnParentCompany, setEWBAuthDetails } from '../../store/common/common_action'
import {
  booking,
  delivery,
  alert,
  monthNames,
  branchTransfer,
  branchTransferReceive,
  receive,
  actvtyOpts,
  dispatchCargo,
  reports,
  PARENT_COMPANY_MODE,
  admin,
  recharge,
  operationsPrivilege,
  deliveryMemo,
  generalSettings,
  acountingReports,
  BrchUsrMaster,
  BookingEnable,
  NotLogin,
  deliveryV2Cargo,
  dashBoard,
  bookingOffline,
  urls,
  API_CACHE_DURATION,
  businessAnalysis,
  mtplMaster,
  updateOutDelivery,
  pendingOutDelivery,
  outDeliveryStatus,
  selectUser,
} from './../common/constants'
import { useNavigate } from 'react-router-dom'
import {
  getCargoCompanySetting,
  updateSelectedActivity,
  getConsignmentSubTypes,
  gMapApiKey,
  getBranchConfigOrEwbillinfo,
  getDashBoardData,
} from '../../store/common/common_action'
import * as mdt from '../common/modaltypes'


import { fetchLogin, updateCityList, updateBrnchList, getCargoRoleRightsConfigListAll } from '../../store/common/common_action'
import { resetActivityData, getMethodOfPacking } from '../../store/common/common_action'
import { getBranchWiseCollectionData, getCargoSettingFilterData } from '../../store/reports/reports_action'
import { setLoginDataToStore } from '../../store/common/common_action'
import BranchTransfer from './BranchTransfer'
import BranchTransferReceive from './BranchTransferReceive'
import { useIsMount } from '../helpers/useIsMount'
import Receive from './Receive'
import { getUpdateDispatchBranch } from '../../store/branchTransferReceive/branchReceive_action'
import { Reports } from './Reports'
import AdminUpdate from './AdminUpdate'
import RechargeDebitCreditNote from './AdminUpdate/RechargeDebitCreditNote/index'
import DeliveryMemo from './DeliveryMemo'
import GeneralSettings from './GeneralSettings'
import AcountingReport from './AcountingReport'
import BranchAndUserMaster from './BrnchUsrMaster'
import { useAtom, useAtomValue, useSetAtom } from 'jotai'
import { DashBoard } from './dashBoard'
import { BusinessAnalysis } from './dashBoard/businessAnalysis'
import { bookingCityListAtom, bookingDisableAtom, branchListAtom, cityListAtom, companySettingsAtom, fetchCargoCompanySettingAtom, fetchCargoRoleRightsAtomAtom, fetchPaybillDetailsAtom, fetchQrProcessignFeeAtom, gstConfigAtom, ownCityBranchListAtom } from '../common/jotaiState/commonStateAtoms'
import { GetRequest, GetRequestCachedV3 } from '../common/api'
import MTPLMasterSetting from './MTPLMaster'
import OperationsPrivilege from './OperationsPrivilege'
import { OutDelivery } from './OutDelivery'
import { PendingOutDelivery } from './OutDelivery/pendingOutDelivery'
import { OutDeliveryStatus } from './OutDelivery/outDeliveryStatus'
import { SelectUser } from './AdminUpdate/SelectUser'
import { alertAtom, modalAtom } from '../common/jotaiState/globalStateAtoms'

const Booking = lazy(() => import('../content/BookingActivity'))
const BookingOffline = lazy(() => import('../content/BookingActivity/bookingOffline'))
const Delivery = lazy(() => import('../content/DeliveryActivity'))
const DispatchCargo = lazy(() => import('../content/DispatchCargo'))
const Alert = lazy(() => import('../common/alert'))
function Content(props) {
  const { data, updateCityList, updateBrnchList, getMethodOfPacking, getCargoRoleRightsConfigListAll, gMapApiKey, getCargoSettingFilterData } = props
  const {
    store,
    getCargoCompanySetting,
    getConsignmentSubTypes,
    fetchLogin,
    setLoginDataToStore,
    getDashBoardData,
    getUpdateDispatchBranch,
  } = props
  const { getBranchConfigOrEwbillinfo, getOwnParentCompany, cargoGetBranchBkgPermission } = props
  const { common } = data
  const { GetExemptedGoodsList, setEWBAuthDetails } = props
  const { loginData: loginDetails, selectedActvty, loginData2 } = { ...common }
  const [searchParams] = useSearchParams()
  const [currentView, setCurrentView] = useState(searchParams.get('view') || '')
  const { loginData, setLoginData } = useToken()
  const [companySettings] = useAtom(companySettingsAtom)
  const [, getCompanySetting] = useAtom(fetchCargoCompanySettingAtom)
  const [, getPaybillDetails] = useAtom(fetchPaybillDetailsAtom)
  const [, getRoleRights] = useAtom(fetchCargoRoleRightsAtomAtom)
  const [, getQrProcessing] = useAtom(fetchQrProcessignFeeAtom)
  const [, setCityList] = useAtom(cityListAtom)
  const [, setBookingCityList] = useAtom(bookingCityListAtom)
  const [, setBranchList] = useAtom(branchListAtom)
  const [, setOwnCityBranchList] = useAtom(ownCityBranchListAtom)
  const [, setGstConfig] = useAtom(gstConfigAtom)
  const disbaleBooking = useAtomValue(bookingDisableAtom)
  const setAlert = useSetAtom(alertAtom)
  const setModal = useSetAtom(modalAtom)
  const { DefaultCurrencyID, IsBookingDeliveryWithQR = 0 } = companySettings

  let navigate = useNavigate()
  const isMount = useIsMount()
  const usePrevious = (value) => {
    const ref = useRef()
    useEffect(() => {
      ref.current = value
    })
    return ref.current
  }
  const prevloginData = usePrevious(loginData)
  useEffect(() => {
    if (IsBookingDeliveryWithQR) {
      getQrProcessing({ CompanyID: loginData?.intCompanyID, PaymentProductTypeID: 1 })
    }
  }, [companySettings])
  useEffect(() => {
    console.log('Release 1.59.4')
    const loginToken = searchParams.get('authentication') || ''
    let loginParams = decryptText(loginToken)
    if (loginParams && loginParams != 'ErrorInDecrypting') {
      loginParams = loginParams.split('~')
      if (loginParams.length === 5 || loginParams.length === 6) {
        const [dateTime, , Code, LoginID, Password, GUID = ''] = loginParams
        const [dateStr, timeStr, meridiem] = dateTime.split(/(\s+)/).filter((e) => e.trim().length > 0)
        const [day, month, year] = dateStr.split('-')
        let [hours, minutes, seconds] = timeStr.split(':')
        if (meridiem === 'PM') {
          hours = +hours
          hours += 12
        }
        const authDateTime = new Date(+year, +monthNames.indexOf(month.substring(0, 3)), +day, +hours, +minutes, +seconds)
        const currentDateTime = new Date()
        const diffTime = Math.abs(currentDateTime - authDateTime)
        const diffHours = Math.ceil(diffTime / (1000 * 60 * 60))
        if (diffHours < 24) {
          sessionStorage.setItem('authentication', loginToken)
          fetchLogin({ Code, LoginID, Password, GUID: encodeURIComponent(GUID) })
          navigate(`/${currentView ? '?view=' + currentView : ''}`)
        } else {
          setCurrentView(alert)
        }
      }
    } else if (!loginData && !(['Dashboard', 'Branch & User Master'].includes(searchParams.get('view')) && searchParams.get('data'))) {
      if (
        window.location.origin.includes('localhost') ||
        window.location.origin.includes('trycloudflare.com') ||
        window.location.origin.includes('userprateek.com')
      ) {
        const loginParams = prompt('Enter Login Details, Format: Password LoginID Code')
        const [Password = 123, LoginID = 'prateekk', Code = 'MBGLR', GUID = ''] = loginParams.split(' ')
        fetchLogin({ Code, LoginID, Password })
        //setCurrentView(alert)
      } else {
        redirectToLogin()
      }
    }
  }, [])
  useEffect(() => {
    if (DefaultCurrencyID === 2) {
      getPaybillDetails({ intCompanyId: loginData?.intCompanyID, intBranchId: loginData?.intBranchID })
    }
  }, [DefaultCurrencyID])
  useEffect(() => {
    if (loginData) {
      const tokenString = sessionStorage.getItem('token1')
      const data2 = JSON.parse(tokenString)
      setLoginDataToStore(loginData, data2)
      gMapApiKey(loginData, 0)

    }
    const inactvtyOpts = actvtyOpts.find((el) => el.value === currentView)
    if (loginData != null && prevloginData == null && !inactvtyOpts) {
      // if(loginDetails?.BranchTypeID===2 ||loginDetails?.BranchTypeID===3){
      //   setCurrentView(selectedActvty)
      // }
      // else{
      //   setCurrentView(NotLogin)
      // }
      setCurrentView(selectedActvty)
    }
  }, [loginData])

  useEffect(() => {
    if (loginData && !isMount) {
      setCurrentView(selectedActvty)
    }
  }, [selectedActvty])
  const getCityList = async () => {
    const res = await GetRequestCachedV3(urls.getCityList, {
      intUserID: loginDetails.intUserID,
      intCompanyID: loginDetails.intCompanyID,
      intStateID: 0,
    }, true, API_CACHE_DURATION)
     const res2 = await GetRequestCachedV3(urls.getdispatchcheckinCities, {
      UserID: loginDetails.intUserID,
      CompanyID: loginDetails.intCompanyID,
      branchID:loginDetails.intBranchID,
      LoginCityID: loginDetails.intBranchCityID,
    }, true, API_CACHE_DURATION)
    updateCityList(res.Data.Table)
    setCityList(res.Data.Table)
    setBookingCityList(res2.Data.Table)
  }
  const getBranchListSheard = async (loginData) => {
    const res = await GetRequestCachedV3(urls.getBranchList, {
      intUserID: loginData.intUserID,
      intCompanyID: loginData.intCompanyID,
      intCityID: 0,
      intBookingBranchID:  0,
    }, true, API_CACHE_DURATION)
    if (res.status == 'Success') {
      const cargoBranches = res.Data.Table.filter((el) => [2, 3].includes(el.BranchTypeID))
      updateBrnchList(cargoBranches, 0)
      updateBrnchList(cargoBranches.filter((el) => el.CityID === loginData.intBranchCityID), 1)
      setBranchList(cargoBranches)
      setOwnCityBranchList(cargoBranches.filter((el) => el.CityID === loginData.intBranchCityID))
      const EWb = cargoBranches.filter((item) => item.BranchID === loginData.intBranchID)
      setEWBAuthDetails(EWb)
    }
  }

  const getGstConfig = async (loginData) => {
    const res = await GetRequest(urls.gstConfig, { CompanyID: loginData.intCompanyID, PaymentType: '1' })
    if (res.status === 'Success') {
      setGstConfig(res.Data.Table?.[0] || {})
    }
  }
  useEffect(() => {
    if (loginDetails !== null) {
      if (!isEmpty(loginDetails)) {
        const { intBranchID, intCompanyID, intUserID, intBranchCityID, intRoleID } = loginDetails
        getCompanySetting({
          intCompanyID,
          intBranchID,
          intUserID,
        })
        getRoleRights({
          intRoleID,
          intUserID,
        })
        getCargoRoleRightsConfigListAll(loginDetails)
        setLoginData(loginDetails)
        //updateSelectedActivity(currentView)
        const parentCompanyParams = {
          intMode: PARENT_COMPANY_MODE,
          intBranchID,
        }
        if(intBranchID){
          getOwnParentCompany(parentCompanyParams)
        }
        const data = {
          IsVisible: 1,
          intCompanyID,
          intBranchID,
          intUserID,
        }
        cargoGetBranchBkgPermission(data)

        getCargoCompanySetting(loginDetails)
        getCityList(loginDetails)
        getGstConfig(loginDetails)
        getBranchListSheard(loginDetails)
        getConsignmentSubTypes(loginDetails, true, 24 * 60 * 60 * 1000)
        getMethodOfPacking(loginDetails, true, 24 * 60 * 60 * 1000)
        //dashboard api
        getDashBoardData(loginDetails, 'BR')
        getDashBoardData(loginDetails, 'R')
        //dashboard api end
        //for branch receive
        getUpdateDispatchBranch(loginDetails, {}, true, 24 * 60 * 60 * 1000)
        //for branch receive end
        const obj = {
          strBranchName: '',
          strBranchCode: '',
          intStateID: 0,
          intCityID: intBranchCityID,
          intIsActive: -1,
          intUserID,
          intCompanyID,
          intBranchID,
        }
        getBranchConfigOrEwbillinfo(obj)
        GetExemptedGoodsList()
      }
    } else {
      setCurrentView(alert)
    }
  }, [loginDetails])
  //
  useEffect(() => {
    const allReports = sessionStorage.getItem('token1');
    const allReportsActive = JSON.parse(allReports);
    if (allReportsActive?.length > 0 && (loginDetails?.IsAdmin == 0 && loginDetails?.IsBranchAdmin == 0 && loginDetails?.IsMTPLAdmin == 0)) {
      if (findObjctByValueFromArrayOfObject(allReportsActive, 53, 'JobID', "IsActive") === 0) {
        setCurrentView(BookingEnable)
      }
    }
  }, [sessionStorage.getItem('token1')])
  useEffect(() => {
    const view = searchParams.get('view')
    if (view) {
      setCurrentView(view)
    }
  }, [searchParams])
  const getActivity = (key) => {
     if (disbaleBooking && ![receive, branchTransferReceive].includes(key)) {
      const close = () => {
        setAlert({ show: false, msg: '', nextId: '' })
        navigate(`/${'?view=' + receive}`)
        setCurrentView(receive)
        setModal(mdt.cargoRechargeRequestModal)
      }
      setAlert({ show: true, msg: 'Please Clear Outstanding Amount !', nextId: '', close })
    }
    let activityUI
    switch (key.toLocaleLowerCase()) {
      case booking.toLocaleLowerCase():
        activityUI = <Booking />
        break
      case bookingOffline.toLocaleLowerCase():
        activityUI = <BookingOffline />
        break
      case delivery.toLocaleLowerCase():
        activityUI = <Delivery />
        break
      case branchTransfer.toLocaleLowerCase():
        activityUI = <BranchTransfer />
        break
      case branchTransferReceive.toLocaleLowerCase():
        activityUI = <BranchTransferReceive />
        break
      case receive.toLocaleLowerCase():
        activityUI = <Receive />
        break
      case dispatchCargo.toLocaleLowerCase():
        activityUI = <DispatchCargo />
        break
      case reports.toLocaleLowerCase():
        activityUI = <Reports />
        break
      case alert.toLocaleLowerCase():
        activityUI = <Alert msg="Invalid Login" error={true} close={redirectToLogin} />
        break
      case admin.toLocaleLowerCase():
        activityUI = <AdminUpdate />
        break
      case selectUser.toLocaleLowerCase():
        activityUI = <SelectUser />
        break
      case recharge.toLocaleLowerCase():
        activityUI = <RechargeDebitCreditNote />
        break
      case operationsPrivilege.toLocaleLowerCase():
        activityUI = <OperationsPrivilege/>
        break
      case deliveryMemo.toLocaleLowerCase():
        activityUI = <DeliveryMemo />
        break
      case generalSettings.toLocaleLowerCase():
        activityUI = <GeneralSettings />
        break
      case acountingReports.toLocaleLowerCase():
        activityUI = <AcountingReport />
        break
      case BrchUsrMaster.toLocaleLowerCase():
        activityUI = <BranchAndUserMaster />
        break
      case BookingEnable.toLocaleLowerCase():
        activityUI = <Alert msg={`Luggage Booking is Not Enabled .\nPlease Contact Your Company Admin`} error={true} close={redirectToLogin} />
        break
      case NotLogin.toLocaleLowerCase():
        activityUI = <Alert msg={`You Are Not Authorized For Cargo Booking. Please Contact Your Admin.`} error={true} close={redirectToLogin} />
        break
      case deliveryV2Cargo.toLocaleLowerCase():
        activityUI = <Delivery isOnlyDelivery={true} />
        break
      case dashBoard.toLocaleLowerCase():
        activityUI = <DashBoard />
        break;
      case businessAnalysis.toLocaleLowerCase():
        activityUI = <BusinessAnalysis />
        break;
      case mtplMaster.toLocaleLowerCase():
        activityUI = <MTPLMasterSetting />
        break;
      case updateOutDelivery.toLocaleLowerCase():
        activityUI = <OutDelivery />
        break;
      case pendingOutDelivery.toLocaleLowerCase():
        activityUI = <PendingOutDelivery />
        break;
      case outDeliveryStatus.toLocaleLowerCase():
        activityUI = <OutDeliveryStatus />
        break;
      default:
        activityUI = <></>
        break
    }
    return activityUI
  }
  return (
    <>
      <Suspense fallback={<LoaderScreen />}>
        <Provider store={store}>{getActivity(currentView)}</Provider>
      </Suspense>
    </>
  )
}

const mapStateToProps = (data) => ({ data })

const mapDispatchToProps = {
  updateSelectedActivity,
  getCargoCompanySetting,
  getCargoRoleRightsConfigListAll,
  updateCityList,
  fetchLogin,
  setLoginDataToStore,
  updateBrnchList,
  getConsignmentSubTypes,
  getMethodOfPacking,
  resetActivityData,
  gMapApiKey,
  getBranchConfigOrEwbillinfo,
  getDashBoardData,
  getUpdateDispatchBranch,
  getOwnParentCompany,
  cargoGetBranchBkgPermission,
  getBranchWiseCollectionData,
  getCargoSettingFilterData,
  GetExemptedGoodsList,
  setEWBAuthDetails
}

export default connect(mapStateToProps, mapDispatchToProps)(Content)
